import { render, staticRenderFns } from "./ProcessCreateOrderDocumentation.vue?vue&type=template&id=667ac318"
import script from "./ProcessCreateOrderDocumentation.vue?vue&type=script&lang=js"
export * from "./ProcessCreateOrderDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports